/* eslint-disable camelcase */
import { cashbackStatusLabels } from "../../utils/formatters";
import style from "./style.module.scss";

type Helper = { [K in keyof typeof cashbackStatusLabels]: string };

export enum TransactionStatus {
	authorized = "authorized",
	canceled = "canceled",
	error = "error",
	expired = "expired",
	paid = "paid",
	pending_refund = "pending_refund",
	processing = "processing",
	refunded = "refunded",
	refused = "refused",
	waiting_payment = "waiting_payment",
}

interface ITransactionStatus {
	className?: string;
	classNamePointer?: string;
	status: TransactionStatus | string;
	helper: Helper;
}

export const NodeTransactionStatus = ({ status, className, classNamePointer, helper }: ITransactionStatus): JSX.Element => {
	return (
		<div className={[className ?? style.status, status].join(" ")}>
			<div className={classNamePointer ?? style.pointer} />
			<span>{helper[status ?? "null"]}</span>
		</div>
	);
};
